import React from "react";
import styles from "@/css/result.module.less";

const BasicInfo = ({ data: { isp, rocketPosition, realSpeed, percent } }) => {
  return (
    <div className={styles["result-basic-info-card"]}>
      <h2 className={styles["isp"]}>{isp}</h2>
      <div className={styles["result-percent-line"]}>
        <img
          className={styles["result-speed-rocket"]}
          style={{
            left: `calc(${rocketPosition} * 0.9)`,
          }}
          src={require("@/images/app-result/rocket.png")}
          alt="rocket"
        />
      </div>
      <div className={styles["result-net-info"]}>
        <p className={styles["result-speed"]}>
          当前网速相当于&nbsp;<em>{realSpeed}</em>&nbsp;带宽
        </p>
        <p>
          已超越全国&nbsp;<em>{percent}</em>&nbsp;的网络用户
        </p>
      </div>
    </div>
  );
};
export default BasicInfo;
